import { render, staticRenderFns } from "./AthleteSpqReportCard.vue?vue&type=template&id=d2ad3f32&scoped=true&"
import script from "./AthleteSpqReportCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteSpqReportCard.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSpqReportCard.vue?vue&type=style&index=0&id=d2ad3f32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ad3f32",
  null
  
)

export default component.exports